import { useEffect, type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom-v5-compat';

import { config } from '@/config/config';
import { env } from '@/env';
import { actions as messagesActions } from '@/modules/messages';

export const NonDemoFirewall = ({ children }: { children: ReactNode }) => {
    const dispatch = useDispatch();
    const intl = useIntl();

    useEffect(() => {
        if (env.VITE_DEMO) {
            dispatch(
                messagesActions.displayWarningMessage({
                    message: intl.formatMessage({ id: 'demo.featureNotAvailable' }),
                }),
            );
        }
    }, [intl, dispatch]);

    if (env.VITE_DEMO) {
        return <Navigate to={config.routes.home} />;
    }

    return <>{children}</>;
};
